import React, {useState} from "react";
import useWithStore from "@/Hooks/useWithStore";
import Svg from "@/Components/Svg";
import Radio from "@/Components/Radio";
import {ClickAwayListener} from '@mui/material';

const Sort = (props) => {
    const {stores = {}, dataSort = [], isDesktop = false} = props;
    const {catalogStore = {}, modalStore = {}} = stores;
    const [flagName, setFlagName] = useState(false);

    const handleClickAway = () => {
        if (flagName) {
            setFlagName(false);
        }
    };

    const toggleSorting = () => {
        if (isDesktop) {
            setFlagName(!flagName);
        } else {
            modalStore.openFilterDrawer(dataSort, 'Сортировка', '', 'sorting');
        }
    };

    const onChangeSorting = (el) => {
        catalogStore.selectedSortingName = el.label;
        catalogStore.selectedSortingValue = el.value;
        catalogStore.changePagination();
        catalogStore.getCatalogData(false);
        // if (flagName) {
            setFlagName(false);
        // }
    };

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <div className={`filters--sorting`}>
                <div className={`dropdown-filter${flagName ? ' open' : ''}`}
                     onClick={() => toggleSorting()}
                     tabIndex={0}
                >
                    <div className={`dropdown-filter__name`}>
                        <Svg id={`sortFiltersIcon`} className={`svg__sortFiltersIcon`} />
                        {isDesktop && (catalogStore.selectedSortingName)}
                    </div>
                    {isDesktop && (
                        <div className={`dropdown-filter__content sort`}>
                            {dataSort.map((el) => {
                                return <Radio
                                    key={el.id}
                                    name={el.label}
                                    value={el.value}
                                    checked={catalogStore.selectedSortingValue === el.value}
                                    onChange={() => onChangeSorting(el)}
                                    label={el.label}
                                />
                            })}
                        </div>
                    )}
                </div>
            </div>
        </ClickAwayListener>
    );
};

export default useWithStore(Sort);
